"use client";

import { useMemo } from "react";

import { TagType } from "~/components/tag/types";
import { Variables } from "~/constants/request";
import { useVariable } from "~/context/variables/hooks/use-variable";

export interface ProductTag {
  key: TagType;
  title: string;
  textColor?: string;
  backgroundColor?: string;
}

export const useProductComingSoonTag = (): ProductTag | null => {
  const productTags = useVariable<{ key: TagType; title: string }[]>(
    Variables.PRODUCT_TAGS,
  );
  const tag = useMemo(
    () =>
      productTags?.find((tag) => {
        return tag.key === TagType.comingSoon;
      }),
    [productTags],
  );

  if (!tag?.key) {
    return null;
  }

  return tag;
};
